// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const claydol: PokeData = {
  "id": 344,
  "name": "claydol",
  "height": 15,
  "weight": 1080,
  "base_experience": 175,
  "types": [
    PokeType.GROUND,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "psybeam",
    "hyper-beam",
    "confusion",
    "teleport",
    "harden",
    "self-destruct",
    "explosion",
    "mud-slap",
    "sandstorm",
    "rapid-spin",
    "ancient-power",
    "imprison",
    "rock-tomb",
    "cosmic-power",
    "extrasensory",
    "heal-block",
    "power-trick",
    "earth-power",
    "guard-split",
    "power-split"
  ],
  "moves": [
    "mud-slap",
    "sandstorm",
    "ancient-power",
    "rock-tomb",
    "earth-power",
    "psy-ball",
    "mud-bomb",
    "mud-shot",
    "reflect",
    "psywave",
    "psychic-terrain",
    "psy-pulse",
    "fissure"
  ],
  "evolution_chain": {
    "id": 175,
    "item": null,
    "species": [
      {
        "name": "baltoy",
        "order": 371,
        "types": [
          PokeType.GROUND,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "claydol",
        "order": 372,
        "types": [
          PokeType.GROUND,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 343,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 149,
    "speed": 130,
    "ability_power": 121
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
